// This standardizes all the signature verification states
// into a single map.
export const SIGNATURE = {
  NOT_VERIFIED_YET: "NOT_VERIFIED_YET",
  INVALID: "INVALID",
  VALID: "VALID",
};
